module.exports = __webpack_public_path__ + "img/chr_ts_9_penlight.ced7ef59.png";